<template>
  <main id="app" class="px-1 pb-3" >

    <div class="row d-flex justify-content-center p-4 mx-4 white">

      <div class="back-transparent w-100 d-flex mb-2 justify-content-center" >  
        <span class="d-flex w-100 justify-content-center px-1 cardDash"> 
         Política de Privacidade  
        </span>  
      </div> 
      <h3>A sua privacidade é importante para nós. </h3>
      <h5>É política do <b>Placa Fipe BR.</b>, respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar em nossos aplicativos.</h5> 
      <h5>Importante: Não representamos nem possuímos vínculo com o Governo Federal do Brasil ou qualquer uma de suas empresas ou entidades governamentais.</h5>
      <h5>As consultas de informações oficiais são realizadas em APIs abertas e extraídas de bases de Dados Abertos (Decreto nº 8.777, de 11 de maio de 2016).</h5>
 
      <h5>Não compartilhamos informações de identificação pessoal publicamente ou com terceiros, exceto quando exigido por lei.</h5>
      <br/>
      <h5><b>ATENÇÃO!</b></h5>
      <br/>
      <h5>• NÃO possuímos nenhum vínculo ou afiliação com nenhuma entidade governamental. Nós também NÃO representamos nenhuma entidade governamental!</h5>

      <h5>O decreto Nº 8.777, de 11 de maio de 2016 define que a API do Governo Federal é de livre utilização por todos.</h5>

      <br/>
      <h5><b>Fonte de Informações Governamentais:</b></h5>
      <br/> 
      <h5>Este aplicativo obtém informações oficiais sobre veículos através de APIs fornecidas pelo gov.br.</h5> 
        
      <h5>Esteja ciente de que não temos controle sobre o conteúdo e práticas desses aplicativos e não podemos aceitar responsabilidade por suas respectivas políticas de privacidade.</h5>
      <h5>Você é livre para recusar a nossa solicitação de informações pessoais, entendendo que talvez não possamos fornecer alguns dos serviços desejados.</h5>
      <h5>O uso continuado de nosso aplicativo será considerado como aceitação de nossas práticas em torno de privacidade e informações pessoais. Se você tiver alguma dúvida sobre como lidamos com dados do usuário e informações pessoais, entre em contacto conosco.</h5>
      <br/>
      <h3>Segurança dos dados</h3>
      <h5>É com grande satisfação que apresentamos a você a mais recente atualização do nosso aplicativo, focada em tornar a sua experiência ainda mais descomplicada e ágil. Reconhecemos a importância da privacidade e simplicidade na interação digital, e é por isso que reformulamos o processo de cadastro, eliminando barreiras desnecessárias.</h5>
      <h5>Agora, para usufruir de todas as funcionalidades incríveis do nosso app, solicitamos apenas duas informações essenciais: seu endereço de e-mail e número de telefone, para que possamos apresentar nosso ranking com os que foram melhores nos testes. Acreditamos que a simplicidade é a chave para uma experiência positiva, e, por isso, optamos por <b>não pedir</b> comprovações adicionais ou documentos.</h5> 
      <h5>O seu e-mail e número de telefone são utilizados exclusivamente para facilitar a comunicação e fornecer a você atualizações relevantes sobre o aplicativo. Asseguramos a você que mantemos essas informações sob rigorosas medidas de segurança, garantindo a confidencialidade dos seus dados.</h5>
      <h5>Ao simplificar o processo de cadastro, buscamos proporcionar a você mais tempo para aproveitar as funcionalidades únicas do nosso app, sem burocracias desnecessárias. Queremos que sua experiência seja positiva desde o primeiro contato, permitindo que você explore todas as vantagens que oferecemos de maneira rápida e intuitiva. </h5>
      <h5>Agradecemos pela confiança em nosso serviço e estamos comprometidos em continuar aprimorando a sua experiência digital. Se tiver alguma dúvida ou sugestão, não hesite em entrar em contato conosco. Estamos aqui para proporcionar a você a melhor experiência possível. </h5>
      <br/>
      <h3>Mais informações</h3>
      <h5>Esperemos que esteja esclarecido e, como mencionado anteriormente, se houver alguma dúvida entre em contacto conosco.</h5>

      <h3>Esta política é efetiva a partir de Julho/2024.</h3>
       
  
    </div> 
     
  
  </main>
</template>

<script> 
 
 
export default {
  name: 'App',
 
  data() {
    return {
      neuroquest: false,
  
    };
  },
 
  mounted(){
    let uri = window.location.search.substring(1); 

    let params = new URLSearchParams(uri);
  
     let app = params.get("app"); 
 

    if(app == 'neuroQuest'){
      this.neuroquest = true
    }
  },
  
}
</script>

<style lang="scss">

.white {
  color: #f7efef;
  font-weight: 600; 
  
  font-family: "serif"; 
  text-shadow: #5f5f5f 1px 1px 5px; 
  h5 {
    font-size: 22px !important;
  }
 
}

 
 
html{
  background-color: #921ef0;
}
  
.img-fluid {
    max-width: 580px !important;
}
 
.back-transparent{
  background-color: #921ef0 !important;
  color: white;
  span {
    font-size: 26px;
    color: '#f7efef';
    font-family: 'serif'; 
    font-weight: 800;
    text-shadow: #000000 2px 2px 10px;
    .medium {
      font-size: 18px;
    }
    .menu {
      font-family: 'Helvetica'; 
      font-weight: bold;
      font-size: 30px; 
      text-align: end;
    }
  }
}
 
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; 
  color: #921ef0; 
  background-color: #921ef0;
  display: flex;
  flex-direction: column;
  height: 100vh;
   
}
main {
  background-image:
    linear-gradient(to bottom, #921ef0, rgba(117, 19, 93, 0.078));
    height: 100vh !important;
  }

 /* Importing fonts from Google */
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap');

 
.alertWarning {
    max-width: 350px; 
    margin: auto;  
    border-radius: 15px;  
}

.wrapper {
    padding-top: 17px !important;
    max-width: 360px;
    min-height: 510px;
    margin: auto; 
    background-color: #ecf0f3;
    border-radius: 15px;
    box-shadow: 3px 3px 3px #cbced1, 3px 3px 20px #fff;
    a {
      color: #03A9F4 !important;
      font-size: 15px !important;
    }
    .btn:hover {
      color: white !important; 
    }
}

.logo {
    width: 70px;
    margin: auto;
}

.logo img {
    width: 100%;
    height: 70px;
    object-fit: fill;
    border-radius: 50%;
    box-shadow: 0px 0px 3px #69ce0b,
        0px 0px 0px 5px #ecf0f3,
        8px 8px 15px #76f076b5,
        -8px -8px 15px #fff;
}

.wrapper .form {
    font-weight: 600;
    font-size: 1.1rem;
    letter-spacing: 1.2px;
    padding-left: 8px;
    color: #555;
}

.wrapper .form-field input {
    width: 100%;
    display: block;
    border: none;
    outline: none;
    background: none;
    font-size: 1.0rem;
    color: #666;
    padding: 8px 13px 8px 8px;
    /* border: 1px solid red; */
}

.wrapper .form-field {
    padding-left: 8px;
    margin-bottom: 20px;
    border-radius: 10px;
    box-shadow: inset 5px 5px 5px #cbced192, inset -3px -3px 3px #fff;
}

.wrapper .form-field .fas {
    color: #555;
}

.wrapper .btn {
    box-shadow: none;
    width: 100%;
    height: 40px;
    background-color: #03A9F4;
    color: #fff;
    border-radius: 25px; 
    letter-spacing: 1.3px;
}

.wrapper .btn:hover {
    background-color: #039BE5;
}
.wrapper .btn:disabled {
    background-color: #039BE5;
    border: none;
}

.wrapper a {
    text-decoration: none;
    font-size: 0.8rem;
    color: #03A9F4;
}

.wrapper a:hover {
    color: #039BE5;
}

.progress-bar-striped {
  background-color: #03A9F4 !important; 
}

@media(max-width: 380px) {
  .wrapper { 
    padding: 30px 15px 15px 15px;
  }
}  

.input-none {
  width: 10px;
  height: 10px;
  z-index: -1;
  position: absolute;
  color: transparent !important;
  border: none;
}

 
</style>
